import * as yup from 'yup';
import mapValues from 'lodash/mapValues';
import { validationMode, validationMessages } from 'helpers/form';

export const pullForwardTimeWindowShape = yup.object().shape({
  fromDate: yup
    .date()
    .typeError(validationMessages.required)
    .required(validationMessages.required),
  returnComponent: yup.string().required(validationMessages.required),
  numberPeriods: yup
    .number()
    .integer(validationMessages.integer)
    .typeError(validationMessages.number)
    .nullable(true)
    .moreThan(0, validationMessages.greaterThanZero)
    .max(1200, validationMessages.numberTooLarge)
    .required(validationMessages.required),
});

/**
 * Validation Scheme used for Pull Forward Benchmarks
 * @param mode Create | Edit - change the shape of the schema object based on Creating/Editing a benchmark.
 * @returns return yup schema object
 */
export const pullForwardValidationScheme = (
  mode: validationMode = validationMode.Create
) => {
  return yup.lazy((obj) =>
    yup.object(
      mapValues(obj, (value, key) => {
        switch (key) {
          case 'timeWindows':
            return mode === validationMode.Create
              ? yup.array().of(pullForwardTimeWindowShape)
              : yup.mixed().notRequired();
          case 'name':
            return yup
              .string()
              .trim()
              .required(validationMessages.benchmarkNameNotEmpty);
          case 'calculationFrequencyId':
            return yup
              .number()
              .typeError(validationMessages.required)
              .required(validationMessages.required);
          case 'baseCurrencyCode':
            return yup
              .string()
              .typeError(validationMessages.required)
              .required(validationMessages.required);
          case 'customLagDate':
            return yup.string().when(['isLagged', 'setCustomLagDate'], {
              is: (isLagged: string, setCustomLagDate: string) =>
                isLagged === 'true' && setCustomLagDate === 'false',
              then: (schema) => schema.required('Please enter a valid date'),
              otherwise: (schema) => schema.notRequired(),
            });
          case 'description':
            return yup
              .string()
              .notRequired()
              .max(350, validationMessages.notExceed350);
          default:
            return yup.mixed().notRequired();
        }
      })
    )
  );
};
